var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridItemCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04736 13.8811C8.8807 13.8811 8.72236 13.8144 8.6057 13.6977L4.34727 10.5311C4.1056 10.2894 4.1056 9.88939 4.34727 9.64772C4.58893 9.40605 4.98893 9.40605 5.2306 9.64772L9.04736 12.3727L15.0555 6.84791C15.2972 6.60624 15.6972 6.60624 15.9389 6.84791C16.1805 7.08957 16.1805 7.48957 15.9389 7.73124L9.48903 13.6977C9.37236 13.8144 9.21403 13.8811 9.04736 13.8811Z",
    fill: "#0ABAB5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridItemCheck);
export default __webpack_public_path__ + "static/media/grid_item_check.91acec7153ce0840bbcafad7d65032ae.svg";
export { ForwardRef as ReactComponent };